import type { IconData } from '@stacksjs/iconify-core'

export const otherUiMaximize: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0H5v11h11z\"/><path fill=\"currentColor\" d=\"M0 8h3v5h5v3H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiMaximize
